// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VendorSignUp_wrapper__38fc_","logo":"VendorSignUp_logo__1snEN"};